import * as React from "react";
export default /*#__PURE__*/ React.createContext({
    isPrefetchMode: false
});

//# sourceMappingURL=PrefetchEnvContext.js.map